import http from '../utils/fetch'


export default {
  pageVisited (data) {
    return http.post({
      url: '/v1/track/page',
      data: data
    })
  },

  pageShared(data) {
    return http.post({
      url: '/v1/track/share',
      data: data,
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/track.js